import styled from 'styled-components';

export const StyledBroadsiderTrait = styled.div`
  display: flex;
  padding: 8px 4px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border: solid 1px ${({ theme }) => theme.traitBorder};
  text-align: center;
  height: ${({ theme }) => theme.traitHeight};
  min-height: ${({ theme }) => theme.traitHeight};
  opacity: ${({ $placeholder}) => $placeholder ? '0': '1.0'};

  .trait-top {
    opacity: 0.4;
    font-family: "BebasNeue";
    font-size: 1em;
    color: white;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .trait-bottom {
    font-family: "NeueMachina";
    font-size: 1em;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;
